import { useStoreActions } from '~/contexts';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { ErrorResponse } from '~/infra/ErrorResponse';
const MAX_RETRY_DELAY_MS = 8000;
const isTransientError = (error)=>{
    const status = error instanceof ErrorResponse ? error.status : null;
    return status == null || status >= 500;
};
export const useRegisterMobileNotification = ()=>{
    const { api } = useStoreActions();
    const { mutate, isLoading, isError } = useMutationState({
        mutationFn: (info)=>api.mobileNotification.register(info),
        retry: (failureCount, error)=>failureCount < 3 && isTransientError(error),
        retryDelay: (attempt)=>Math.min(1000 * 2 ** attempt, MAX_RETRY_DELAY_MS)
    });
    return {
        registerMobileNotification: mutate,
        isLoading,
        isError
    };
};
